"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_SYSTEM_SETTING = void 0;
const react_1 = __importDefault(require("react"));
const schema_1 = __importDefault(require("./schema"));
const schemaComponents_1 = require("@/schemaComponents");
const standard_1 = require("react-hook-schema/standard");
const models_hook_1 = require("app/models.hook");
const __1 = require("..");
const locale_1 = require("utils/locale");
const auth_1 = require("common/auth");
exports.UPDATE_SYSTEM_SETTING = __1.SYSTEM_SETTING.sub("/edit", Project);
// export const ADD_PROJECT = PROJECTS.sub("/edit/new", Project);
function Project() {
    (0, auth_1.useAdminPageAuthorization)();
    const projectId = "default";
    console.log("Project", { projectId });
    const { data, loading, set, remove, isEditing, ref } = (0, models_hook_1.useProjectDoc)({
        projectId,
    });
    const parameter = {
        title: "システム設定",
        schema: (0, schema_1.default)(),
        edit: {
            title: `${isEditing ? "保存" : "保存"}`,
            confirm: `${isEditing ? "保存" : "保存"}しますか？`,
            handler: set,
        },
        header: {
            isStacked: true,
        },
        // remove: isEditing ? { handler: remove } : undefined,
    };
    console.log("Project", { isEditing, ref, projectId, data, parameter });
    return (react_1.default.createElement(schemaComponents_1.SchemaFormPage, { data: data, parameter: parameter, loading: isEditing && loading, header: react_1.default.createElement(standard_1.AdminLocaleSelector, { locales: locale_1.availableLocales }), editModeEnabled: true }));
}
exports.default = Project;
